/*
*   File : e-sign.js
*   Author : https://evoqins.com
*   Description : Screen to verify E-sign
*   Version : 1.0.0
*/

// import packages
import { Fragment, useEffect, useState } from "react";
import { Modal } from "bootstrap";
import { toast } from "react-toastify";

// import components
import { PrimaryButton } from "../../../Components/Buttons";
import { Icon } from "../../../Components/Icon";
import { StepProgress } from "../../../Components/Other";
import { KYCConfirmationModal } from "../../../Components/Modal";
import { KYCProgressCard } from "../../../Components/Card";

// import services
import APIService from "../../../Services/api-service";
import { _getSignupProgress } from "../../../Helper/api";


const ESign = (props) => {
    const [showSuccess, setShowSuccess] = useState(false);
    const [apiLoader, setApiLoader] = useState(false);
    const [acceptedTerms, setAcceptedTerms] = useState(true);


    useEffect(() => {
        if (showSuccess === true) {
            const modal = new Modal(document.getElementById("confirm"));
            modal.show();
        }
    }, [showSuccess]);


    // open success modal 
    function _showSuccess(status) {
        setShowSuccess(status);
        if (status === false) {
            props.handleNavigate()
        }
    }

    // API - create esign url
    const _generateESignUrl = () => {
        setApiLoader(true);
        const url = "/kyc/create-esign";
        APIService(false, url).then((response) => {
            toast.dismiss();
            if (response.status_code === 200) {
                let e_sign_window = window.open(response.data.redirect_url, '_blank');

                let timer = setInterval(function () {
                    if (e_sign_window.closed) {
                        clearInterval(timer);
                        _getSignupProgress().then((response) => {
                            _showSuccess(true)
                        })
                    }
                }, 1000);
            } else {
                toast.error(response.message, {
                    type: "error"
                });
            }
            setApiLoader(false);
        })
    }


    return (
        <Fragment>
            <Icon icon="Arrow-Right"
                size={32}
                className="margin-12px-tb rotate-left cursor-pointer"
                onClick={props.navigateBack} />
            <div className="row pt-md-4 pt-0">
                <div className="col-md-7">
                    <StepProgress type={2}
                        gotToStep={(step, index) => props.gotToStep(step, index)}
                        completed={props.completedStep}
                        stepCompleted={props.investmentStep}
                    />
                    <h6 className="color-eerie-black e-font-20 e-line-height-32 e-montserrat-semi-bold mb-2 padding-32px-top">
                        E- sign documents
                    </h6>
                    <p className="color-gunmental e-font-16 e-line-height-32 e-montserrat-regular mb-0">
                        Your account opening agreement has been created. Please e-sign it by clicking the button below.
                    </p>
                    <img src={require("../../../Assets/Images/KYC/esign.png")}
                        alt="esign"
                        draggable={false}
                        className="w-100 h-auto my-4" />
                    <div className="d-flex align-items-center gap-8px w-fit-content">
                        <Icon icon={acceptedTerms ? "checked" : "unchecked"}
                            size={20}
                            onClick={() => setAcceptedTerms(!acceptedTerms)}
                            className="cursor-pointer" />
                        {/* <p className="mb-0 e-montserrat-medium e-font-14 e-line-height-24 letter-spacing-007em pt-2">
                            I agree to the MINTIT <a href={process.env.REACT_APP_TERMS} target="_blank" className="color-rebecca-purple e-link">terms and conditions</a>. Also, I assure that I will read <LinkButton className="e-font-16 e-line-height-30"
                                onPress={() => window.open("https://www.sebi.gov.in/sebiweb/other/OtherAction.do?doMutualFund=yes&mftype=3", "_blank")}
                                label="KIM" /> & <LinkButton className="e-font-16 e-line-height-30"
                                    onPress={() => window.open("https://www.sebi.gov.in/sebiweb/other/OtherAction.do?doMutualFund=yes&mftype=2", "_blank")}
                                    label="SID" /> of funds before investments.
                        </p> */}
                    </div>

                    <div className="border-top-1px border-bright-gray margin-32px-top mb-4"></div>
                    <div className="col-xl-4 col-lg-6 col-md-7 d-md-block d-none">
                        <PrimaryButton label="E-sign the agreement"
                            disabled={apiLoader}
                            className="w-100 padding-12px-tb"
                            image={require("../../../Assets/Images/KYC/digi-btn.png")}
                            onPress={_generateESignUrl} />
                    </div>
                </div>
                <div className="col-md-5">
                    <KYCProgressCard steps={props.investment_steps}
                        completedStep={props.completedStep} />
                    <div className="col-sm-6 d-md-none d-block pt-3">
                        <PrimaryButton label="Proceed"
                            disabled={apiLoader}
                            className="w-100 padding-12px-tb"
                            image={require("../../../Assets/Images/KYC/digi-btn.png")}
                            onPress={_generateESignUrl} />
                    </div>

                </div>
            </div>

            {
                showSuccess === true && <KYCConfirmationModal title="Congratulations"
                    type={1}
                    showButton={true}
                    content="The account creation process has been
                    initiated and the process will take 1-3 business days time. We will notify overmail once it is completed."
                    closeModal={() => _showSuccess(false)}
                    handleNavigate={props.handleNavigate} />
            }

        </Fragment >
    )
}

export default ESign;